<template>
	<TopNavFooter>
  <div class="main-content" id="admin" style="">
  <spinner :spinnerOn="loading"></spinner>
    <div class="container-fluid" style="background: #fff;padding: 0px;padding-top:35px;">
	<div class="modal deleteConfirmModal" role="dialog" aria-hidden="true">
	<div class="modal-dialog">
        <div class="modal-content" style="color: #00524A;">
          <div class="modal-header" style="display: block;">
		  <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9" style="font-weight:bold;float: left;width: 90%;">{{user_lang.delete}}</div>
        <button type="button" class="close" data-dismiss="modal" style="background:#ffffff !important;color:#000 !important">&times;</button>
		  <h4 style="font-size: 18px;"></h4></div>
          <div class="modal-body">
		   <div style="margin-right: 233px;width: 100%;text-align: left;">
		  <label for="message-text" class="form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12"
		  style="font-size: 18px;font-weight:normal !important;">{{user_lang.wanttodeleteadminconfig}} </label>
		  </div>
		  <a class="btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12" href="#" @click.prevent="removeConfirm()" style="margin-top: 15px;">{{user_lang.yes}}</a>
		  <a class="btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12" href="#" data-dismiss="modal" style="margin-top: 15px;">{{user_lang.no}}</a>
          <!--div class="col-12" style="margin-bottom: 15px;color: green;" v-show="resetSuccess"> Successfully Updated. </div -->
	  </div>
	  </div>
	  </div>
    </div>
	<div class="modal cannotDeleteModal" role="dialog" aria-hidden="true">
	<div class="modal-dialog">
        <div class="modal-content" style="color: #00524A;">
          <div class="modal-header" style="display: block;border:0px !important;">
		  <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9" style="float: left;width: 90%;margin: 10px;">{{user_lang.cannotdeleteconfig}}</div>
        <button type="button" class="close" data-dismiss="modal" style="background:#ffffff !important;color:#000 !important">&times;</button>
		  <h4 style="font-size: 18px;"></h4></div>
	  </div>
	  </div>
    </div>
      <!-- BEGIN: CONTAINER -->
      <div class="container">
	  <div style="margin:-15px">
	  <div class="bc-adduser">
      <div style="font-size: 44px !important;font-weight: bold;overflow: auto;margin-bottom: 15px;"><span>API Settings</span>
	  </div>
	  </div>
	  </div>
	  <div style="font-size: 14px;margin: 10px 0px;">
	  Note: This section is to provide applications to use one cargill APIs.</div>
</div>
		<!--div v-for = "i in clientList">{{i.clientId}}</div-->
		<div class="row">
		<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 configGroupAdmin table-responsive">
     <table class="table">
	 <tr>
		 <th>Allowed Application</th>
		 <th>Brand</th>
		 <th style="min-width: 200px;">Allowed groups</th>
		 <th>&nbsp;</th>
		 </tr>
         <tr v-for="(i,index) in appAdminGroupModal">
		 <td style="min-width: 250px;">
		 <select v-bind:id="'select'+ i.applicationId" style="width:100%;" v-model = "appAdminGroupModal[index].applicationId"
		 @change="getGroups(i.applicationId)"
		 v-bind:class = "{disabledLight: appAdminGroupModal[index].applicationId !== undefined &&
		 appAdminGroupModal[index].applicationId !== 'undefined' && appAdminGroupModal[index].groupId !== ''}">
		 <option value="undefined">{{user_lang.selectapp}}</option>
		 <option v-bind:value="j.id" v-for = "j in appList"  v-if="j.name !== 'bookmark'" v-show = "i.appGrpId === undefined">{{j.label}}</option>
		 <!--&& !isAlreadyConfiged(j.id)-->
		 </select>
		 </td>
		 
		 <td style="min-width: 200px;">
		 <select v-bind:id="'selectbrand'+ i.applicationId" style="width:100%;" v-model = "appAdminGroupModal[index].brand"
		 v-bind:class = "{disabledLight: appAdminGroupModal[index].applicationId !== undefined &&
		 appAdminGroupModal[index].applicationId !== 'undefined' && appAdminGroupModal[index].groupId !== ''}">
		 <option value="undefined">{{user_lang.selectBrand}}</option>
		 <option v-bind:value="j.brandKey" v-for = "j in brandDetails.data">{{j.brandName}}</option>
		 </select>
		 </td>
		 <!--&& !isAlreadyConfiged(j.id)-->
		 <td style="min-width: 250px;">
		 <div v-if="" id="dropdown">
			<div class="selectDropDown" v-on:click= "openDropDown(index)">
			<span style="padding-left: 5px;"><span v-if="appAdminGroupModal[index].subGroupId && appAdminGroupModal[index].subGroupId.length == 0">
			{{user_lang['selectgroupslist']}} </span>
			<span v-if="appAdminGroupModal[index].subGroupId && appAdminGroupModal[index].subGroupId.length > 0">
			Selected ({{appAdminGroupModal[index].subGroupId ? appAdminGroupModal[index].subGroupId.length : '0'}})</span>
			<i class="fa fa-caret-down"
			style="float: right;margin: 4px 5px;margin-top:-10px;"></i></span></div>
			 <div id="checkboxlist" v-show="showDropDown[index.toString()]" v-bind:class="'ddwrap'+index">
					<div v-for="j in appsGroups[i.applicationId]" style="padding-right: 15px;padding-left: 5px;" class="dd-list-item"><!--v-if="appAdminGroupModal[index].groupId !== j.id"-->
					  <input v-bind:id = "j.id + '~' + index" class="form-control input-checkbx-sub" type="checkbox" v-bind:value = "j.id" @change="checkchange($event)"></input>
					  <label style="vertical-align: super;" v-bind:for = "j.id">{{j._embedded.group.profile.name}}</label>
					  </div>
					  <div v-for="j in appAdminGroupModal[index].subGroupId" 
					  v-if="j.indexOf('~~~') > -1 && appGroupsArrayMap[i.applicationId].indexOf(j.split('~~~')[0]) === -1"
					  style="padding-right: 15px;padding-left: 5px;" class="dd-list-item"><!--v-if="appAdminGroupModal[index].groupId !== j.id"-->
					  <input v-bind:id = "j.split('~~~')[0] + '~' + index" class="form-control input-checkbx-sub"
					  type="checkbox" v-bind:value = "j.split('~~~')[0]" @change="checkchange($event)"></input>
					  <label style="vertical-align: super;" v-bind:for = "j.split('~~~')[0]">{{j.split('~~~')[1]}}</label>
					  </div>
					</div>
			</div>
			<span v-for="j in appsGroups[i.applicationId]" v-if="appAdminGroupModal[index].subGroupId && appAdminGroupModal[index].subGroupId.indexOf(j.id) > -1" 
			style="display: block;">-{{j._embedded.group.profile.name}}</span><!--appAdminGroupModal[index].appGrpId!=undefined &&-->
			<span v-for="j in appAdminGroupModal[index].subGroupId" v-if="j.indexOf('~~~') > -1 && appGroupsArrayMap[i.applicationId].indexOf(j.split('~~~')[0]) === -1"
			style="display: block;">-{{j.split('~~~')[1]}}</span>
			<div style="font-weight:bold;margin-top: 5px;">Add additional group:</div>
			<input type ="text" class="addgrouptxtbox" v-model="additionalGroup[index]" placeholder="Enter group name and click +"/>
			<i class="fa fa-plus-circle" style="font-size: 20px;cursor: pointer;color: rgb(101, 141, 27);margin-left: 10px;" @click="addAdditionalGroup(index, i.applicationId)"></i>
		 </td>
		 <td style="min-width: 80px;">
	     <button @click="removeRow(i.appGrpId, index, i.applicationId)" class="deleteconfig">Delete</button>
		 <!--i class="fa fa-times-circle remove-group" @click="removeRow(i.appGrpId, index, i.applicationId)"></i-->
		 <!--i class="fa fa-plus-circle" style="font-size: 20px;color: rgb(101, 141, 27);cursor: pointer;margin-left: 10px;"
		 v-if = "index === appAdminGroupModal.length-1" @click="addConfigRow()"></i-->
		 </td>
		 </tr>
      </table>
	  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"></div>
     </div>
		</div>
		<div class="row">
	  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin:15px;color:red" v-show="isIncomplete">
	  {{user_lang.adminConfigIncomplete}}</div>
	  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin:15px;color:green" v-show="saveSuccess">
	  {{user_lang.adminconfigupdatesuccess}}</div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" 
	  style="margin:15px;color:green" v-show="deleteSuccess">
	  {{user_lang.adminconfigdeletesuccess}}</div>
	  </div>
	 <div class="row">
	  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="text-align:right;">
	  <button @click="saveAdminGroups()" style="margin-right: 15px;line-height: 16px;cursor:pointer;font-size: 17px;border-radius:2px;">{{user_lang.save}}</button>
	  <button @click="addConfigRow()" style="margin-right: 15px;line-height: 16px;cursor:pointer;border-radius:2px;">Add New App</button>
	  </div>
	  </div>
	  </div>
    </div>  <!-- END: container -->
    </div>
</TopNavFooter> </template>
<script>
  import TopNavFooter from "@/components/widgets/TopNavFooter"
  import idmApi from '@/idm-api'
  import Spinner from '@/components/Spinner';
  import { locale } from '@/i18n/locale.js'
  import { EventBus } from '@/event-bus.js';
  import storage from '@/helpers/storage';
  import Vue from 'vue';
  const apiUrl = process.env.API_URL;
  const onecargillappid = process.env.KEY_ID;
  let brandDetails = "";
  let environment = process.env.NODE_ENV;
  if (environment === 'production') {
    brandDetails = require('../brand-details.json');
  } else if (environment === 'stage') {
    brandDetails = require('../brand-details-stage.json');
  } else {
    brandDetails = require('../brand-details-dev.json');
  }
  export default {
    name: 'tm',
    components: {
      TopNavFooter,
      Spinner
    },
    created() {
      // this.changeCustomer();
      var self = this;
      self.loading = true
      self.userId = storage.get('cf-user').sub
      self.email = storage.get('email')
      this.user_lang = this.lang_br
      setTimeout(self.assignUserLang(), 1000) // lang_br for br portuguese
      EventBus.$on('lang', function (language) {
        self.user_lang = self.lang_obj[language]
      })
      self.getListOfSuperUserApps()
    },
    mounted () {
      var self = this
      var tempshowDropDown = {}
      for (var i = 0; i < 100; i++) {
        tempshowDropDown[i.toString()] = false
      }
      self.showDropDown = tempshowDropDown
      $(document).ready(function() {
        $('[data-toggle="tooltip"]').tooltip();
      });
      $(document).on('click', 'body', function (e) {
        if (!$('div#dropdown').has(e.target).length) {
          var tempshowDropDown = {}
          for (var i = 0; i < 100; i++) {
            tempshowDropDown[i.toString()] = false
          }
          self.showDropDown = tempshowDropDown
        }
      })
      /* $(document).on('change', '.input-checkbx-sub', function (e) {
        var grpid = (e.target.id.split('~')[0])
        var idx = (e.target.id.split('~')[1])
        // console.log(self.appAdminGroupModal)
        if (self.appAdminGroupModal[idx].subGroupId === undefined) {
          self.appAdminGroupModal[idx]['subGroupId'] = []
        }
        if (e.target.checked && self.appAdminGroupModal[idx].subGroupId.indexOf(grpid) === -1) {
          self.appAdminGroupModal[idx].subGroupId.push(grpid)
        } else {
          self.appAdminGroupModal[idx].subGroupId = self.appAdminGroupModal[idx].subGroupId.filter(e => e !== grpid);
        }
        // console.log(self.appAdminGroupModal)
      }) */
    },
    watch: {
      appAdminGroupModal: function () {
        this.watchAppAdminGroupModal()
      }
    },
    methods: {
      watchAppAdminGroupModal() {
        var self = this
        console.log('watch')
        if (this.appAdminGroupModal.length === 0) {
          var newRowObj = $.extend(true, {}, self.rowObj)
          self.appAdminGroupModal.push(newRowObj)
        }
      },
      assignUserLang() {
        var self = this
        self.user_lang = self.lang_obj[this.lang]
      },
      addAdditionalGroup (index, appid) {
        var self = this
        self.loading = true
        idmApi.getGroupByName(`${apiUrl}/auth/groups/search?groupName=${self.additionalGroup[index]}`).then(response => {
          self.addAdditionalGroupImpl(response, index, appid)
        }).catch(err => {
          self.loading = false
          console.log(err)
        })
      },
      addAdditionalGroupImpl(response, index, appid) {
        var self = this
        // console.log(response)
        self.loading = false
        if (response.data.length === 0) {
          window.alert('Please enter valid group name')
          self.additionalGroup = []
        } else {
          var fl = self.appsGroups[appid].filter(x => x.id === response.data[0].id)
          if (fl.length === 0) {
            var indieSubGroupEntry = response.data[0].id + '~~~' + response.data[0].profile.name
            self.appAdminGroupModal[index].subGroupId.push(indieSubGroupEntry.trim())
            self.additionalGroup = []
          } else {
            window.alert('Please select this group from the dropdown')
            self.additionalGroup = []
          }
        }
      },
      checkchange (e) {
        console.log(e)
        var self = this
        var grpid = (e.target.id.split('~')[0])
        var idx = (e.target.id.split('~')[1])
        if (self.appAdminGroupModal[idx].subGroupId === undefined) {
          self.appAdminGroupModal[idx]['subGroupId'] = []
        }
        if (e.target.checked && self.appAdminGroupModal[idx].subGroupId.indexOf(grpid) === -1) {
          self.appAdminGroupModal[idx].subGroupId.push(grpid)
        } else {
          self.appAdminGroupModal[idx].subGroupId = self.appAdminGroupModal[idx].subGroupId.filter(e => e.indexOf(grpid) === -1);
        }
      },
      openDropDown(index) {
        var self = this
        self.showDropDown[index.toString()] = !self.showDropDown[index.toString()]
        if (self.appAdminGroupModal[index].subGroupId === undefined) {
          self.appAdminGroupModal[index]['subGroupId'] = []
        }
        for (var i = 0; i < self.appAdminGroupModal[index].subGroupId.length; i++) {
          var sel = ''
          if (self.appAdminGroupModal[index].subGroupId[i].indexOf('~~~') > -1) {
            sel = '.ddwrap' + index + ' [id^="' + self.appAdminGroupModal[index].subGroupId[i].split('~~~')[0] + '"]'
          } else {
            sel = '.ddwrap' + index + ' [id^="' + self.appAdminGroupModal[index].subGroupId[i] + '"]'
          }
          $(sel).attr('checked', true)
        }
      },
      getListOfClientId() {
        var self = this
        idmApi.getClientIds(`${apiUrl}/apitokenList`, self.email).then(function (response) {
          self.loading = false
          self.clientList = response.data
        }).catch(err => {
          self.loading = false
          console.log(err)
        })
      },
      getListOfSuperUserApps() {
        var self = this
        self.clearMessages()
        idmApi.getListOfSuperUserApps(`${apiUrl}/auth/apps`, self.email).then(function (response) {
          self.loading = false
          self.appList = response.data
          self.appList.sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase()) ? 1 : ((b.label.toLowerCase() > a.label.toLowerCase()) ? -1 : 0));
          self.getConfigList()
          /* for (var i = 0; i < response.data.length; i++) {
            self.getGroups(response.data[i].id)
          } */
        }).catch(err => {
          self.loading = false
          console.log(err)
        })
      },
      getGroups(id) {
        var self = this
        self.clearMessages()
        if (self.appsGroups[id] === undefined && id !== 'undefined' && id !== undefined) {
          self.loading = true
          idmApi.getGroupsByAppId(`${apiUrl}/auth/apps/${id}/groups`).then(function (response) {
            self.loading = false
            var gmap = response.data.map(x => x.id)
            Vue.set(self.appGroupsArrayMap, id, gmap)
            Vue.set(self.appsGroups, id,
            response.data.sort((a, b) => (a._embedded.group.profile.name.toLowerCase() >
            b._embedded.group.profile.name.toLowerCase()) ? 1 : ((b._embedded.group.profile.name.toLowerCase() >
            a._embedded.group.profile.name.toLowerCase()) ? -1 : 0)))
            // self.appsGroups[id] = response.data
          }).catch(err => {
            console.log(err)
          })
        }
      },
      addConfigRow() {
        var self = this
        self.clearMessages()
        var newRowObj = $.extend(true, {}, self.rowObj)
        self.appAdminGroupModal.push(newRowObj)
      },
      getConfigList() {
        var self = this
        self.loading = true
        idmApi.getListOfAdminConfig(`${apiUrl}/auth/apiconfig/appGroupList`).then(function (response) {
          self.loading = false
          self.appAdminGroupModal = response.data
          if (self.appAdminGroupModal.length > 0) {
            self.appAdminGroupModal.map(function(i) {
              self.getGroups(i.applicationId)
            })
          } else {
            self.addConfigRow()
          }
        }).catch(err => {
          console.log(err)
        })
      },
      saveAdminGroups() {
        var self = this
        self.clearMessages()
        self.loading = true
        var filteredList = self.appAdminGroupModal.filter(i => (i.applicationId !== 'undefined' && i.applicationId !== undefined))
        self.isIncomplete = filteredList.some((i) => {
          if (i.brand === 'undefined' || i.brand === undefined || (i.subGroupId && i.subGroupId.length === 0)) {
            return true
          }
        })
        if (!self.isIncomplete) {
          // filteredList.map(function(obj) { obj.email = self.email; })
          idmApi.addToAdminConfigDB(`${apiUrl}/auth/apiconfig/appGroup`, filteredList).then(function (response) {
            self.loading = false
            self.getConfigList()
            self.updateAdminConfigsInLocal()
            if (response.data.status.statusCode === "500") {
              window.alert(response.data.status.status)
            } else {
              setTimeout(function() { self.saveSuccess = true }, 500)
            }
          }).catch(err => {
            console.log(err)
          })
        } else {
          self.loading = false
        }
      },
      populateOptionDetails(appId, index) {
        var self = this
        self.clearMessages()
        self.appsGroups[appId].some(function(i) {
          if (i.id === self.appAdminGroupModal[index].groupId) {
            self.appAdminGroupModal[index].groupId = i._embedded.group.id
            return true
          }
        })
        /* self.appList.some(function(i) {
          if (i.id === appId) {
            self.appAdminGroupModal[index].application.applicationName = i.label
            return true
          }
        }) */
      },
      removeRow(appgrpId, index, gn) {
        var self = this
        self.currRemoveId = appgrpId
        self.currRemoveIndex = index
        if (gn === onecargillappid) {
          self.clearMessages()
          $('.cannotDeleteModal').modal('show')
        } else {
          self.clearMessages()
          $('.deleteConfirmModal').modal('show')
        }
      },
      removeConfirm() {
        var self = this
        self.loading = true
        self.appAdminGroupModal.splice(self.currRemoveIndex, 1)
        var data = {"appGrpId": self.currRemoveId}
        // delete from db
        idmApi.deleteAdminConfig(`${apiUrl}/auth/apiconfig/appGroup`, data).then(function (response) {
          self.loading = false
          $('.deleteConfirmModal').modal('hide')
          self.deleteSuccess = true
          self.updateAdminConfigsInLocal()
        }).catch(err => {
          console.log(err)
        })
      },
      cancelRemove() {
        $('.deleteConfirmModal').modal('hide')
      },
      clearMessages() {
        var self = this
        self.isIncomplete = false
        self.saveSuccess = false
        self.deleteSuccess = false
      },
      isAlreadyConfiged(id) {
        var self = this
        var listOfConfigedApps = self.appAdminGroupModal.map(function(i) {
          return i.applicationId
        })
        return (id === onecargillappid && listOfConfigedApps.indexOf(id) > -1)
      },
      updateAdminConfigsInLocal() {
        var self = this
        idmApi.getListOfAdminConfig(`${apiUrl}/auth/apiconfig/appGroupList`).then(function (response) {
          self.persistInLocal(response)
        }).catch(err => {
          console.log(err)
        })
      },
      persistInLocal(response) {
        var adminGroupsArr = []
        var adminAppsArr = []
        adminGroupsArr = response.data.map(function(i) {
          return i.groupId
        })
        adminAppsArr = response.data.map(function(i) {
          return i.applicationId
        })
        storage.set('adminConfigMaster', JSON.stringify(response.data))
        storage.set('adminConfigJSON', JSON.stringify(adminGroupsArr))
        storage.set('adminConfigJSONApps', JSON.stringify(adminAppsArr))
      }
    },
    data() {
      return {
        brandDetails: brandDetails,
        additionalGroup: [],
        showDropDown: {"0": false, "1": false, "2": false, "3": false, "4": false, "5": false, "6": false, "7": false, "8": false, "9": false, "10": false},
        lang: locale.lang,
        lang_obj: locale.lang_obj,
        userId: '',
        loading: false,
        user_lang: {},
        prefLang: 'en_US',
        email: '',
        clientList: [],
        appList: [],
        appsGroups: {},
        appGroupsArrayMap: {},
        modalObj: {},
        selectModel: {},
        optionModel: {},
        appAdminGroupModal: [{"applicationId": "undefined", "brand": "cargill", "groupId": "", "subGroupId": []}],
        rowObj: {"applicationId": "undefined", "brand": "cargill", "groupId": "", "subGroupId": []},
        isIncomplete: false,
        saveSuccess: false,
        deleteSuccess: false,
        currRemoveId: '',
        currRemoveIndex: ''
      }
    },
    computed: {
    }
  }
</script>
<style scoped>
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
    padding: 0;
  }
.custom-select {
	display: inline-block;
	max-width: 100%;
	height: calc(2.50rem + 2px);
	padding: 0.375rem 1.75rem 0.375rem 0.75rem;
	line-height: 1.25;
	background-color: #ececeb;
	vertical-align: middle;
	background-size: 8px 10px;
	border: 1px solid #00524A;
	border-radius: 0;
	-moz-appearance: none;
	-webkit-appearance: none;
}
.card-block {
	background: #eceff1;
}
.user-input {
	width: 100%;
	background: #ffffff;
	color: #333333;
	height: 30px;
}
.user-select {
	color: #333333;
	height: 30px;
}
#userSearch {
	margin: 10px;
}
.good-table th {
	color: #333333 !important
}
.btn-secondary:active {
	background: #007299;
	box-shadow: none;
}
.btn-secondary {
	background: var(--theme-primary);
	color: #ffffff;
}
input {
	width: 130px;
	box-sizing: border-box;
	border: 1px solid var(--theme-primary);
	border-radius: 0;
	font-size: 16px;
	background-color: #f1f1f1;
	background-position: 10px 10px;
	background-repeat: no-repeat;
	padding: 15px 20px;
	height: 50px;
}
.card {
	position: relative;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	-ms-flex-direction: column;
	flex-direction: column;
	background-color: #33373D;
	border: 0px solid rgba(0, 0, 0, 0.125);
	border-radius: 0px;
	box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px
		rgba(0, 0, 0, 0.22);
	box-shadow: 0 6px 8px 0 rgba(0, 0, 0, 0.4);
}
.card {
	margin-bottom: 1rem;
	box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1);
}
.card-block1 {
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    padding: 0rem;
}
#searchId {
	box-sizing: border-box !important;
	border: 2px solid #dde3e6 !important;
	border-radius: 0 !important;
	background-color: #fff !important;
	background-position: 10px 10px !important;
	background-repeat: no-repeat !important;
	height: 40px !important;
	margin-bottom: 18px !important;
	margin-left: 30px !important;
}
.filter-label{ width: 150px;
    float: left;
    font-size: 14px;
    margin-top: 8px;
    font-weight: bold;
}
.btn-secondary {
	background-color: var(--theme-primary);;
	border-color: #00433c;
}
.btn-secondary:hover {
	background-color: #00524A;
	border-color: #00433c;
}
.btn {
	padding: 14px 24px;
	border: 0 none;
	font-weight: 700;
	letter-spacing: 1px;
	text-transform: uppercase;
}
.input-adduser{
    height: initial;
    padding: 5px 15px;
    width: 100%;
	background: #fff;
	margin: 0px !important
}
.input-checkbx-sub{
width: 20px;
height: 20px !important;
display: inline-block;
}
.preflang{
    width: 100%;
    min-height: 34px;
	}
.success-bg{
    background: #90ee90;
}
.error-bg{
   background: #ffc0cb;
}
.form-control-label{min-width: 120px;font-size:12px;}
.wrap-input{display:block;overflow:hidden}
.form-wrap{    margin-bottom: 3px;}
.create-btn{margin-top: 10px;
    height: 40px;
    line-height: 0px;font-size: 12px;float:right;}
.search-icon{margin-top: 10px;
    margin-top: 0px;
    height: 40px !important;
    line-height: 0px;
    padding: 12px 24px 14px 24px;
	margin-bottom: 10px;
    border-radius: 0px;}
.tableContainer{padding: 0px 15px 30px;    overflow-x: auto;}
.input-group{
    width: 100%;
    background: #fff;
    margin: 0px -15px 0p;
    padding: 5px;
    outline: 15px solid #fff;
    /* margin: 0px -15px; */
}
.input-group-btn {max-width:65px}
.sub-group{display: inline-block}
@media (max-width: 1050px) {
  .input-group {
    width:100% !important;
	display: block;
  }
}
@media (max-width: 768px) {
  .sub-group {
    width:100% !important;
	display: block;
  }
  .searchId{max-width: 230px;}
  .filter-text{margin-left: 0px !important}
  .adduser-btn{margin-left: 0px !important}
}
.dropdown div, .dropdown dt {
    margin:0px;
    padding:0px;
}
.dropdown ul {
    margin:0px;
    padding:0px;
}
.dropdown div {
    position:relative;
    margin:0px;
    padding:0px;
}
.dropdown a, .dropdown a:visited {
    color:#fff;
    text-decoration:none;
    outline:none;
    margin:0px;
    padding:0px;
    min-height: 30px;
    border-radius: 3px;
}
.dropdown div a {
    background-color:#4F6877;
    display:block;
    overflow: hidden;
    width:100%;
    margin:0px;
    padding:0px;
}
.dropdown div a span, .multiSel span {
    cursor:pointer;
    display:inline-block;
    margin:0px;
    padding:5px 10px;
}
.dropdown div ul {
    background-color: #4F6877;
    top:1px;
    color:#fff;
    display:none;
    position:absolute;
    width:100%;
    list-style:none;
    height: 100px;
    overflow: auto;
    margin:0px;
    padding:0px;
}
.dropdown span.value {
    display:none;
    border-radius: 3px;
    margin:0px;
    padding:0px;
}
.dropdown div ul li a {
    display:block;
    margin:0px;
    padding:0px;
}
.dropdown div ul li a:hover {
    background-color:#fff;
    margin:0px;
    padding:0px;
}
.selectDropDown{border: 2px solid #dde3e6;height:34px;
    /* border-radius: 3px; */
    cursor: pointer;
    background: #fff;
	width: 100%;}
#checkboxlist{position: relative;
    margin-top: 0px;
	background:#fff;
	border: 1px solid #ccc;
	min-width: 200px;}
.dd-list-item:hover{background:#fff}
button {background:var(--theme-primary) !important}
.adduser-btn{margin-left: 20px;max-height: 40px;margin-top: 0px;line-height: 0px;height: 40px;background-color: var(--theme-primary);font-size: 12px;}
input, select{
background: #fff!important;
    border: 2px solid #dde3e6!important;
	padding-left: 10px !important;
    font-size: 14px !important;}
.bc{font-size:10px;font-weight:bold;}
.bc-adduser{font-size:10px;font-weight:bold;margin:15px}
.bc-nav:hover{text-decoration:underline; cursor:pointer}
.user-creds{background:#fff;    padding: 5px 10px 10px;
    margin-bottom: 12px;}
.bb0{border-top:0px !important}
.add-group{color:var(--theme-primary);font-size:18px;float:right;margin-top: 5px;cursor:pointer}
.remove-group{color: #d80842;
    font-size: 20px;
    /* float: right; */
    margin-top: 6px;
    cursor: pointer;}
.group-div{border:2px solid #eceff1;padding: 3px 10px;}
.group-name{display: inline-block;width: 90%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;}
.usercreateinfo{margin-top: 10px;background: #546e7a;color: #fff;padding: 10px;margin-bottom: 10px;}
@media screen and (max-width: 767px) {
.main-content{padding-top:25px}
.main-content{padding-left:0px}
}
@media screen and (min-width: 768px) {
.main-content{padding-top:0px}
.main-content{padding-left:200px}
}
@media screen and (min-width: 991px) {
.search-bar-wrapper{width: 100%}
.search-bar-select{width: 300px;}
}
@media screen and (max-width: 991px) {
.search-bar-wrapper{width: 75%}
.search-bar-select{width: 150px;}
}
.cancel-btn{    float: right;
    display: block;
    padding: 18px 30px;}
input, select { height: 32px !important; color: #000 !important}
button { height: 32px !important; color: #fff !important}
.disabled {pointer-events:none;opacity:0.5}
.disabledLight {pointer-events:none;opacity:0.8}
.error{    color: red;width: 100%;
    margin-left: 15px;}
.pwderror{max-width:initial;width:100%;font-size: 14px;}
.codeVerifybtn{
background:#f9f9f9;
color:#595959;
border:1px solid #c3c3c3;
font-size:13px;
display: inline-block !important;
 margin-top: -2px;
 height: 30px;
 line-height: 14px;
 width: 87px;}
.fa-check-circle {font-size:40px !important}
label{margin-bottom:0px !important;font-weight:normal !important;font-size:13px;}
user-creds label{font-weight: normal !important;}
.sometext-hidden{
-webkit-user-select: none; /* Chrome/Safari */
-moz-user-select: none; /* Firefox */
-ms-user-select: none; /* IE10+ */
}
.configGroupAdmin tr, td, th{padding-top: 5px;padding-bottom:5px;}
.configGroupAdmin tr{border-bottom: 1px solid #eceff1;}
.configGroupAdmin th {padding: 10px !important;}
.addgrouptxtbox{    width: 85%;
    border: #ccc 1px solid !important;
    border-radius: 2px;
    margin-top: 5px;}
.deleteconfig{
margin-right: 15px;
line-height: 13px;
cursor:pointer;
padding: 6px;
font-size: 13px;
 border-radius: 3px;
 background: #bf6161  !important;
 box-shadow: rgba(216, 21, 33, 0.75) 0px 0px 20px inset;
 max-height: 30px;
 margin-top: 2px;
 }
 
 td:nth-child(2) span {
    max-width: 500px !important;
    display: block;
}
</style>



// WEBPACK FOOTER //
// APISettingsOld.vue?0664b388